module.exports = __webpack_public_path__ + "images/FinanceSectionImage__4b038afbdb569175369fe972b8d74424.jpg";